"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SimpleCaller__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [{
    internalType: "address",
    name: "target",
    type: "address"
  }, {
    internalType: "bytes",
    name: "data",
    type: "bytes"
  }],
  name: "callFunction",
  outputs: [{
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  stateMutability: "payable",
  type: "function"
}];
const _bytecode = "0x608060405234801561001057600080fd5b506102ec806100206000396000f3fe60806040526004361061001e5760003560e01c80639c23da5014610023575b600080fd5b610036610031366004610167565b61004c565b6040516100439190610267565b60405180910390f35b60606001600160a01b0383166100a25760405162461bcd60e51b8152602060048201526016602482015275496e76616c696420746172676574206164647265737360501b60448201526064015b60405180910390fd5b600080846001600160a01b031634856040516100be919061029a565b60006040518083038185875af1925050503d80600081146100fb576040519150601f19603f3d011682016040523d82523d6000602084013e610100565b606091505b5091509150816101495760405162461bcd60e51b8152602060048201526014602482015273119d5b98dd1a5bdb8818d85b1b0819985a5b195960621b6044820152606401610099565b949350505050565b634e487b7160e01b600052604160045260246000fd5b6000806040838503121561017a57600080fd5b82356001600160a01b038116811461019157600080fd5b9150602083013567ffffffffffffffff808211156101ae57600080fd5b818501915085601f8301126101c257600080fd5b8135818111156101d4576101d4610151565b604051601f8201601f19908116603f011681019083821181831017156101fc576101fc610151565b8160405282815288602084870101111561021557600080fd5b8260208601602083013760006020848301015280955050505050509250929050565b60005b8381101561025257818101518382015260200161023a565b83811115610261576000848401525b50505050565b6020815260008251806020840152610286816040850160208701610237565b601f01601f19169190910160400192915050565b600082516102ac818460208701610237565b919091019291505056fea2646970667358221220c6274602378b69cad4f56242b81e2cb56ec3320e612704f322bab45af74785be64736f6c63430008090033";

const isSuperArgs = xs => xs.length > 1;

class SimpleCaller__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.SimpleCaller__factory = SimpleCaller__factory;

_defineProperty(SimpleCaller__factory, "bytecode", _bytecode);

_defineProperty(SimpleCaller__factory, "abi", _abi);